export default function NotFound() {
  return (
    <main>
      <h2>404 Not Found</h2>

      <p>Oops. Something went wrong.</p>
    </main>
  );
}